<div class="row" *ngIf="(tableItem | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col">
                <label class="fw-bold">Record Type</label>
                <select name="recordTypeID" class="form-select" [(ngModel)]="tableItem.recordTypeID">
                    <option *ngFor="let item of recordTypeList" value="{{item.recordTypeID}}">{{item.recordTypeName}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Prefix</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.tagTypePrefix" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Name</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.tagTypeName" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Description</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.tagTypeDescription" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Color Class</label>
                <select name="colorClassName" class="form-select" [(ngModel)]="tableItem.colorClassName">
                    <option value="primary" class="text-primary">primary</option>
                    <option value="secondary" class="text-secondary">secondary</option>
                    <option value="info" class="text-info">info</option>
                    <option value="success" class="text-success">success</option>
                    <option value="warning" class="text-warning">warning</option>
                    <option value="danger" class="text-danger">danger</option>
                    <option value="dark" class="text-dark">dark</option>
                    <option value="light" class="text-light">light</option>
                </select>
                <!--<input type="text" class="form-control" [(ngModel)]="tableItem.colorClassName" required />-->
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <label class="fw-bold">Tracking Visible?</label>
                <input type="checkbox" id="activeInd" name="isTrackingVisible" style="margin:10px;transform: scale(1.5);" [(ngModel)]="tableItem.isTrackingVisible" />
            </div>
            <div class="col-sm-6">
                <label class="fw-bold">Active</label>
                <input type="checkbox" id="isActive" name="isActive" style="margin:10px;transform: scale(1.5);" [(ngModel)]="tableItem.isActive" />
            </div>
        </div>
        <div class="row">
            <div class="col m-2 text-end">
                <button class="btn btn-primary m-2" (click)="save()">Save</button>
                <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>
